module.exports = __webpack_public_path__ + "static/media/1.030514c9.jpg";